module.exports = __webpack_public_path__ + "static/media/contacto.a0fc35bf.jpg";